import { post, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'
import { handleApiResponse } from './api_util';


async function createOrgUser(orgID,userData){
    const payload={
        apiName: 'LivisiblyOrgApi',
        path: `orgs/${orgID}/users`,
        options: {
          body: {
            user_data: userData,
          }
        }
      }
  
      const restOperation = post(payload); 
  
        
      const response = await restOperation.response;
      return processResponse(response)
  }

  async function getOrgUsers(orgID){
  
     const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/${orgID}/users`
      
    }
  
    const restOperation = get(payload); 
  
      
    const response = await restOperation.response;
    
    return processResponse(response)
  }

  async function getOrgUser(orgID,userID){
    const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/${orgID}/users/${userID}`
    }
  
    const restOperation = get(payload); 
  
      
    const response = await restOperation.response;
    return processResponse(response)
  }

  async function updateOrgUser(orgID,userData){
    const payload={
        apiName: 'LivisiblyOrgApi',
        path: `orgs/${orgID}/users`,
        options: {
          body: {
            user_data: userData,
          }
        }
      }
  
      const restOperation = put(payload); 
  
        
      const response = await restOperation.response;
      return processResponse(response)
  }
  
  async function deleteOrgUser(orgID,userID){
    console.log(`in deleteOrgUser, orgID=${orgID}, userID=${userID}`)
    const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/${orgID}/users/${userID}`,
    }
    const restOperation = del(payload); 
    const response = await restOperation.response;
    return processResponse(response)
  
  }

// Create org user
export function useCreateOrgUser() {
    return async (orgID,userData) => {
      try {
        const response = await createOrgUser(orgID,userData);
        return handleApiResponse(['ORGUSERS',orgID],'userID',response, 'create');
      } catch (error) {
        console.error('Error creating org user:', error);
        throw error;
      }
    };
  }

  export function useGetOrgUsers(orgID,shouldFetch=true){
    const result = useSWR(
      shouldFetch ? ['ORGUSERS',orgID] : null,
      (path) => getOrgUsers(orgID)
    );
    return result;
  }
  
  export function useGetOrgUser(orgID,userID, shouldFetch=true){
    const result = useSWR(
      shouldFetch ? [['ORGUSERS', orgID], userID] : null,
      ([path, orgID]) => getOrgUser(orgID, userID)
    );
    return result;
  }

  // Update org users
export function useUpdateOrgUser() {
    return async (orgID,updatedData) => {
      try {
        const response = await updateOrgUser(orgID,updatedData);
        return handleApiResponse(['ORGUSERS',orgID],'userID',response, 'update');
      } catch (error) {
        console.error('Error updating org user:', error);
        throw error;
      }
    };
  }
  
  
  // Delete org user
  export function useDeleteOrgUser() {
    return async (orgID,userID) => {
      try {
        const response = await deleteOrgUser(orgID,userID);
        return handleApiResponse(['ORGUSERS',orgID],'userID',response, 'delete');
      } catch (error) {
        console.error('Error deleting org user:', error);
        throw error;
      }
    };
  }
  